import React from 'react';
import  GitaDharaClass3to5  from 'views/GitaDharaClass3to5';

const AccountGeneralPage = () => {
  return <GitaDharaClass3to5 />;
};

export default AccountGeneralPage;